export default "__VITE_ASSET__b6105c95__"